module.exports = __webpack_public_path__ + "static/2-b0001360c30c8634b78c03c2febb35e4.jpg";